import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useEffect, useRef, useState } from 'react';
import findFatura from '../../service/findFatura';
import { SortOrder } from 'primereact/api';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import { Dropdown } from 'primereact/dropdown';
import React from 'react';
import findClient from '../../service/findClient';
import { Toolbar } from 'primereact/toolbar';
import findFaturamento from '../../service/findFaturamento';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import getFaturaDownload from '../../service/getFaturaDownload';
import getFaturaDownloadConsulta from '../../service/getFaturaDownloadConsulta';
import getFaturaDownloadRegistro from '../../service/getFaturaDownloadRegistro';
import gerarBoletoFatura from '../../service/gerarBoletoFatura';
import gerarPdfFatura from '../../service/gerarPdfFatura';
import gerarNotaFiscalFatura from '../../service/gerarNotaFiscalFatura';
import putFaturaRegistrarPagamentoService from '../../service/putFaturaRegistrarPagamento';
import postFaturaDescontoService from '../../service/postFaturaDesconto';
import patchFaturaIncobravel from '../../service/patchFaturaIncobravel';
import postFaturaManual from '../../service/postFaturaManual';
import { Tooltip } from 'primereact/tooltip';
import { Badge } from 'primereact/badge';
import { Nullable } from 'primereact/ts-helpers';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';


export default function FaturaPage() {
  const { t } = useTranslation();
  const [faturas, setFaturas] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const [expandedRows, setExpandedRows] = useState(undefined);
  const {state} = useGlobalState();
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [clients, setClients] = useState<any>([]);
  const [selectedFaturamento, setSelectedFaturamento] = useState<any>(null);
  const [faturamentos, setFaturamentos] = useState<any>([]);
  const [counts, setCounts] = useState([]);
  const toast = useRef<Toast>(null);
  const [status, setStatus] = useState<Nullable<String | null>>(null);
  const [registrarPagamentoVisible, setRegistrarPagamentoVisible] = useState(false);
  const [faturaBaixaManual, setFaturaBaixaManual] = useState<any>(null);
  const [valorPago, setValorPago] = useState<number | null>(null);
  const [dataPagamento, setDataPagamento] = useState<Date | null>(null);
  const [descontoVisible, setDescontoVisible] = useState(false);
  const [faturaDesconto, setFaturaDesconto] = useState<any>(null);
  const [valorDesconto, setValorDesconto] = useState<number | null>(null);
  const [descricaoDesconto, setDescricaoDesconto] = useState<string>('');
  const [faturaManualVisible, setFaturaManualVisible] = useState(false);
  const [clienteFaturaManual, setClienteFaturaManual] = useState<any>(null);
  const [faturamentoFaturaManual, setFaturamentoFaturaManual] = useState<any>(null);
  const [faturaManualTipo, setFaturaManualTipo] = useState<string>('NOTA_FISCAL_BOLETO');
  const [faturaManualVencimento, setFaturaManualVencimento] = useState<Date | null>(null);
  const [faturaManualItens, setFaturaManualItens] = useState<any[]>([{ descricao: '', quantidade: 1, valorUnitario: null }]);
  const tiposFaturaManual = [
    { label: 'Nota Fiscal e Boleto', value: 'NOTA_FISCAL_BOLETO' },
    { label: 'Nota Fiscal', value: 'NOTA_FISCAL' },
    { label: 'Boleto', value: 'BOLETO' },
    { label: 'Pix', value: 'PIX' },
  ];

  useEffect(() => {
    if(!state.user.cliente){
      const lazyClient = {
        first: 0,
        rows: 99999999,
        page: 1,
        cliente: 'null',
        documento: 'null',
        codigo: 'null',
        inativo: null,
        idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'nome',
        sortOrder: SortOrder.DESC
      }
      const clientes : any[] = [];
      
      findClient(lazyClient).then(data => {
        data.clientes.forEach( (c: { nome: string; id: string; }) => {
          clientes.push({name: c.nome, code:c.id})
        })
      })
      setClients(clientes);
    }

    const lazyFaturamento = {
      first: 0,
      rows: 20,
      page: 1,
      data: null,
      status: null,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: 'dataReferencia',
      sortOrder: SortOrder.DESC
    }
    const faturamentos : any[] = [];
    
    findFaturamento(lazyFaturamento).then(data => {
      data.faturamentos.forEach( (c: { dataReferencia: Date; id: string; }) => {
        faturamentos.push({name: formatDate(c.dataReferencia), code:c.id})
      })
      setSelectedFaturamento(faturamentos[0])
      changeFaturamento(faturamentos[0])
    })
    setFaturamentos(faturamentos);

  },[])
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    faturamento: selectedFaturamento ? selectedFaturamento.code : null,
    cliente: selectedClient ? selectedClient.code : null,
    idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    status: status,
    sortField: 'cliente.nome',
    sortOrder: SortOrder.ASC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      faturamento: selectedFaturamento ? selectedFaturamento.code : null,
      cliente: selectedClient ? selectedClient.code : null,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      status: status,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      faturamento: selectedFaturamento ? selectedFaturamento.code : null,
      cliente: selectedClient ? selectedClient.code : null,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      status: status,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const rowExpansionTemplate = (data:any) => {
    
    return (
        <div>
            <h5>Itens Fatura</h5>
            <DataTable value={data.itens}>
                <Column field="servico" header={t('servico')} sortable></Column>
                <Column field="quantidade" header={t('quantidade')} sortable></Column>
                <Column field="valor" header={t('valor')} sortable></Column>
                <Column field="total" header={t('total')} sortable></Column>
            </DataTable>
        </div>
    );
  };

  const loadLazyData = () => {
    findFatura(lazyState).then(data => {setTotalRecords(data.total);setCounts(data.resumos);setFaturas(data.faturas)}).catch(() => {setTotalRecords(0);setCounts([]);setFaturas(undefined)});
  }

  const changeCliente = (value:any) => {
    setSelectedClient(value);
    setlazyState({
      first: 0,
    rows: 10,
    page: 1,
    faturamento: selectedFaturamento ? selectedFaturamento.code : null,
    cliente: value ? value.code : null,
    idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    status: status,
    sortField: 'cliente.nome',
    sortOrder: SortOrder.ASC
    });
  };

  const changeFaturamento = (value:any) => {
    setSelectedFaturamento(value);
    setlazyState({
      first: 0,
    rows: 10,
    page: 1,
    faturamento: value ? value.code : null,
    cliente: selectedClient ? selectedClient.code : null,
    idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    status: status,
    sortField: 'cliente.nome',
    sortOrder: SortOrder.ASC
    });
  };

  const startContent = (
    <div className="filtros">
      <div className="filtros-grid">
        <div className="filtros-item">
          <label htmlFor="faturamento" className="font-bold">{t("faturamento")}</label>
          <Dropdown inputId="faturamento" value={selectedFaturamento} onChange={(e) => { changeFaturamento(e.value) }} options={faturamentos} optionLabel="name" placeholder="Selecione Faturamento" filter />
        </div>
        {!state.user.cliente && (
          <div className="filtros-item">
            <label htmlFor="cliente" className="font-bold">{t("cliente")}</label>
            <Dropdown inputId="cliente" value={selectedClient} onChange={(e) => { changeCliente(e.value) }} options={clients} optionLabel="name" placeholder="Selecione Cliente" showClear filter />
          </div>
        )}
      </div>
    </div>
  );

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
  };

  

  const downloadFatura = (fatura: any) => {
    getFaturaDownload(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "octet/stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fatura.pdf`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    });

    
  };

  const downloadFaturaRegistro = (fatura: any) => {
    getFaturaDownloadRegistro(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "octet/stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fatura_registro.pdf`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    });
  };

  const downloadFaturaConsulta= (fatura: any) => {
    getFaturaDownloadConsulta(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "octet/stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fatura_consulta.pdf`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    });
  };

  const gerarBoleto = (fatura: any) => {
    gerarBoletoFatura(fatura.id).then((response: any) => {
      toast.current?.show({ severity: 'success', summary: 'Boleto', detail: response, life: 5000 });
    }).catch(() => {
      toast.current?.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao gerar boleto', life: 5000 });
    });
  };

  const isFaturaBaixaManualElegivel = (fatura: any) => {
    const statusFatura = fatura.statusFatura;
    if (statusFatura === 'VENCIDO' || statusFatura === 'RECEBIVEL') {
      return true;
    }
    if (statusFatura === 'PDF_GERADO' && fatura.dataVencimento) {
      return true;
    }
    return false;
  };

  const parseValor = (valor: any): number | null => {
    if (valor === null || valor === undefined || valor === '') return null;
    if (typeof valor === 'number') return isNaN(valor) ? null : valor;
    const normalizado = String(valor).replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
    const numero = parseFloat(normalizado);
    return isNaN(numero) ? null : numero;
  };

  const abrirDialogoBaixaManual = (fatura: any) => {
    setFaturaBaixaManual(fatura);
    setValorPago(parseValor(fatura.valor));
    setDataPagamento(new Date());
    setRegistrarPagamentoVisible(true);
  };

  const fecharDialogoBaixaManual = () => {
    setRegistrarPagamentoVisible(false);
    setFaturaBaixaManual(null);
    setValorPago(null);
    setDataPagamento(null);
  };

  const confirmarBaixaManual = () => {
    if (!faturaBaixaManual || valorPago === null || !dataPagamento) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe valor pago e data de pagamento',
        life: 4000
      });
      return;
    }
    putFaturaRegistrarPagamentoService({
      id: faturaBaixaManual.id,
      valorPago: valorPago,
      dataPagamento: dataPagamento
    })
      .then(() => {
        toast.current?.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Pagamento registrado com sucesso',
          life: 4000
        });
        fecharDialogoBaixaManual();
        loadLazyData();
      })
      .catch((error: any) => {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: error?.message || 'Erro ao registrar pagamento',
          life: 5000
        });
      });
  };

  const abrirDialogoDesconto = (fatura: any) => {
    setFaturaDesconto(fatura);
    setValorDesconto(null);
    setDescricaoDesconto('');
    setDescontoVisible(true);
  };

  const fecharDialogoDesconto = () => {
    setDescontoVisible(false);
    setFaturaDesconto(null);
    setValorDesconto(null);
    setDescricaoDesconto('');
  };

  const confirmarDesconto = () => {
    if (!faturaDesconto || valorDesconto === null || !descricaoDesconto.trim()) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe valor e descrição do desconto',
        life: 4000
      });
      return;
    }
    postFaturaDescontoService({
      idFatura: faturaDesconto.id,
      valorDesconto: valorDesconto,
      descricao: descricaoDesconto
    })
      .then(() => {
        toast.current?.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Desconto aplicado com sucesso',
          life: 4000
        });
        fecharDialogoDesconto();
        loadLazyData();
      })
      .catch((error: any) => {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: error?.message || 'Erro ao aplicar desconto',
          life: 5000
        });
      });
  };

  const downloadNotaFiscal = (fatura: any) => {
    gerarNotaFiscalFatura(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `nota_fiscal_${fatura.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const gerarPdf = (fatura: any) => {
    gerarPdfFatura(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fatura_${fatura.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const marcarIncobravel = (fatura: any) => {
    patchFaturaIncobravel(fatura.id)
      .then((response: any) => {
        toast.current?.show({ severity: 'success', summary: 'Sucesso', detail: response, life: 4000 });
        loadLazyData();
      })
      .catch((error: any) => {
        toast.current?.show({ severity: 'error', summary: 'Erro', detail: error?.response?.data || 'Erro ao marcar como incobrável', life: 5000 });
      });
  };

  const abrirFaturaManual = () => {
    setClienteFaturaManual(selectedClient);
    setFaturamentoFaturaManual(selectedFaturamento);
    setFaturaManualTipo('NOTA_FISCAL_BOLETO');
    setFaturaManualVencimento(null);
    setFaturaManualItens([{ descricao: '', quantidade: 1, valorUnitario: null }]);
    setFaturaManualVisible(true);
  };

  const fecharFaturaManual = () => {
    setFaturaManualVisible(false);
    setClienteFaturaManual(null);
    setFaturamentoFaturaManual(null);
  };

  const adicionarItemManual = () => {
    setFaturaManualItens([...faturaManualItens, { descricao: '', quantidade: 1, valorUnitario: null }]);
  };

  const removerItemManual = (index: number) => {
    setFaturaManualItens(faturaManualItens.filter((_: any, i: number) => i !== index));
  };

  const atualizarItemManual = (index: number, campo: string, valor: any) => {
    const novos = [...faturaManualItens];
    novos[index] = { ...novos[index], [campo]: valor };
    setFaturaManualItens(novos);
  };

  const endContent = (
    <>
      {state.user.funcoes?.includes("FATURA_CADASTRAR") && (
        <Button
          icon="pi pi-plus"
          label="Nova Fatura Manual"
          style={{ backgroundColor: '#183462', border: 'none' }}
          onClick={abrirFaturaManual}
        />
      )}
    </>
  );

  const confirmarFaturaManual = () => {
    if (!clienteFaturaManual) {
      toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Selecione um cliente', life: 4000 });
      return;
    }
    if (!faturamentoFaturaManual) {
      toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Selecione um faturamento', life: 4000 });
      return;
    }
    if (faturaManualItens.some((i: any) => !i.descricao || !i.quantidade || !i.valorUnitario)) {
      toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Preencha todos os itens', life: 4000 });
      return;
    }
    postFaturaManual({
      idCliente: clienteFaturaManual.code,
      idFaturamento: faturamentoFaturaManual.code,
      tipoFaturaManual: faturaManualTipo,
      dataVencimento: faturaManualVencimento,
      itens: faturaManualItens
    })
      .then((response: any) => {
        toast.current?.show({ severity: 'success', summary: 'Sucesso', detail: response, life: 4000 });
        fecharFaturaManual();
        loadLazyData();
      })
      .catch((error: any) => {
        toast.current?.show({ severity: 'error', summary: 'Erro', detail: error?.response?.data || 'Erro ao criar fatura manual', life: 5000 });
      });
  };

  const downloadTemplate = (fatura: any) => {
    return (
      <>
        {state.user.funcoes.includes("FATURA_IMPRIMIR") && (
            <>
              <Button
                icon="pi pi-file-pdf"
                onClick={() => {
                  downloadFatura(fatura);
                }}
                style={{
                  background: "transparent",
                  color: "gray",
                  border: "none",
                }}
              />
              {fatura.possuiRegistro &&  (
                <Button
                  icon="pi pi-id-card"
                  onClick={() => {
                    downloadFaturaRegistro(fatura);
                  }}
                  style={{
                    background: "transparent",
                    color: "gray",
                    border: "none",
                  }}
                />
              )}
              {fatura.possuiConsulta &&  (
                <Button
                  icon="pi pi-search"
                  onClick={() => {
                    downloadFaturaConsulta(fatura);
                  }}
                  style={{
                    background: "transparent",
                    color: "gray",
                    border: "none",
                  }}
                />
              )}
              {state.user.funcoes.includes("FATURA_PDF") && fatura.linhaDigitavel &&  (
                <Button
                  icon="pi pi-download"
                  tooltip="Gerar PDF"
                  onClick={() => {
                    gerarPdf(fatura);
                  }}
                  style={{
                    background: "transparent",
                    color: "gray",
                    border: "none",
                  }}
                />
              )}
              {state.user.funcoes.includes("FATURA_REGISTRAR_PAGAMENTO") && isFaturaBaixaManualElegivel(fatura) && (
                <Button
                  icon="pi pi-check-square"
                  tooltip="Registrar pagamento"
                  onClick={() => {
                    abrirDialogoBaixaManual(fatura);
                  }}
                  style={{
                    background: "transparent",
                    color: "gray",
                    border: "none",
                  }}
                />
              )}
              {state.user.funcoes.includes("FATURA_DESCONTO") && fatura.statusFatura === 'PREPARACAO' && (
                <Button
                  icon="pi pi-percentage"
                  tooltip="Realizar desconto"
                  onClick={() => {
                    abrirDialogoDesconto(fatura);
                  }}
                  style={{
                    background: "transparent",
                    color: "gray",
                    border: "none",
                  }}
                />
              )}
              {state.user.funcoes.includes("FATURA_ADMINISTRAR") && fatura.statusFatura !== 'PAGO' && fatura.statusFatura !== 'INCOBRAVEL' && (
                <Button
                  icon="pi pi-ban"
                  tooltip="Marcar como Incobrável"
                  onClick={() => {
                    marcarIncobravel(fatura);
                  }}
                  style={{
                    background: "transparent",
                    color: "gray",
                    border: "none",
                  }}
                />
              )}
              {state.user.funcoes.includes("FATURA_GERAR_NOTA_FISCAL") && (
                <Button
                  icon="pi pi-file"
                  tooltip="Baixar Nota Fiscal"
                  onClick={() => {
                    downloadNotaFiscal(fatura);
                  }}
                  style={{
                    background: "transparent",
                    color: "gray",
                    border: "none",
                  }}
                />
              )}
            </>
          )}
      </>
    );
  };

  const changeStatus = (status: Nullable<any>) => {
      status = status ? status : null
      if (status instanceof Object) {
        status = null
      }
      setStatus(status);
      setlazyState({
        first: 0,
        rows: 10,
        page: 1,
        faturamento: selectedFaturamento ? selectedFaturamento.code : null,
        cliente: selectedClient ? selectedClient.code : null,
        idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        status: status,
        sortField: 'cliente.nome',
        sortOrder: SortOrder.ASC
      });
  
    }

  const headerCard = (item: any) => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "flex-end" }} className="flex-consulta">
          {status && status === item.status && (<Button icon="pi pi-times" className='button_remove_backgroung' onClick={(e) => { e.stopPropagation(); changeStatus(null) }} text style={{ color: 'rgb(24, 52, 98)' }} aria-label="Cancel" />)}
        </div> </>
    )
  };

  const footerCard = (item: any) => {
      return (
        <>
          <div style={{ display: "flex-consulta", justifyContent: "flex-end" }} className="flex-consulta">
            <span style={{ color: 'rgb(24, 52, 98)' }} className="font-bold text-md">R$ {item.total}</span>
          </div> </>
      )
    };
  
    const statusTemplate = (item: any) => {
      if(item.vencimento && item.status === 'PDF_GERADO'){
        const vencimento = new Date(item.vencimento);
        const hoje = new Date();
        if(vencimento < hoje){
          item.status = 'VENCIDO';
          item.label = 'Vencido';
        }
        else{
          item.status = 'RECEBIVEL';
          item.label = 'Recebível';
        }
      }
      const statusClassMap: { [key: string]: string } = {
        'PREPARACAO': 'status-badge-incluido',
        'GERANDO_BOLETO': 'status-badge-incluido',
        'BOLETO_GERADO': 'status-badge-incluido',
        'RECEBIVEL': 'status-badge-total',
        'VENCIDO': 'status-badge-erro',
        'PAGO': 'status-badge-registrado',
        'INCOBRAVEL': 'status-badge-excluido'
      };
      const statusClass = statusClassMap[item.status] || 'status-badge-excluido';
      return <Badge value={item.label} className={statusClass} />
    }

  useEffect(() => {
    if(lazyState.faturamento){
      loadLazyData();
    }
    
  },[lazyState])

  return (
    <Container>
      <Toast ref={toast} />
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-dollar" style={{ fontSize: '2.0rem' }}></i> {t('faturas')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
       <Toolbar start={startContent} end={endContent} />
        <br></br>
        <br></br>
        <div className="flex-consulta  flex-wrap gap-3">
          {counts.map((item: any, index: number) => (
            <Card footer={footerCard(item)} style={{ cursor: 'pointer' }} className={(status && status !== item.status ? 'flex-1 disabled' : 'flex-1') + (status && status === item.status ? ' show-hide' : '')} header={headerCard(item)} key={index} onClick={() => changeStatus(item.status !== 'undefined' ? item.status : null)}>
              <div className="flex-consulta  justify-content-between gap-5">
                <div className="flex-consulta  flex-column gap-1">
                  <span className="text-secondary text-sm">{statusTemplate(item)}</span>
                  <span className="font-bold text-lg">{item.value}</span>
                </div>
                <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: item.status === 'VENCIDO' ? 'var(--red-500)' : (item.status === 'PREPARACAO' ? 'var(--blue-500)' : (item.status === 'PAGO' ? 'var(--green-500)' : (item.status === 'RECEBIVEL' ? 'var(--teal-500)' : (item.status === 'INCOBRAVEL' ? 'var(--gray-500)' : 'var(--orange-500)')))), color: '#ffffff' }}>
                  <i className={'pi ' + item.icon} />
                </span>
              </div>
            </Card>

          ))}
        </div>
        <br></br>
        <DataTable value={faturas} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros" expandedRows={expandedRows} onRowToggle={(e:any) => setExpandedRows(e.data)}
                        rowExpansionTemplate={rowExpansionTemplate}
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           <Column expander={true} style={{ width: '1.5rem' }} />              
           <Column field="cliente" sortable sortField='cliente.nome' header={t('cliente')}  />
           <Column field="dataReferencia" sortable header={t('dataReferencia')}  />
           <Column field="dataVencimento" sortable header={t('dataVencimento')}  />
           <Column field="valorMinimo" sortable header={t('vcm')}  /> 
           <Column field="valorConsumo" sortable header={t('valorConsumo')}  /> 
           <Column field="valorComplementar" sortable header={t('valorComplementar')}  /> 
           <Column field="valor" sortable header={t('valor')}  /> 
           <Column field="dataPagamento" sortable header={t('dataPagamento')}  />
           <Column field="valorPagamento" sortable header={t('valorPagamento')}  />
           <Column body={(item) => statusTemplate({status:item.statusFatura, label: item.statusFaturaLabel, vencimento: item.dataVencimento})} sortable header={t('status')}  /> 
           <Column style={{width: '11%'}} body={downloadTemplate} />
        </DataTable>
      </div>
      <Dialog
        visible={registrarPagamentoVisible}
        header="Registrar Pagamento"
        modal
        style={{ width: '420px' }}
        onHide={fecharDialogoBaixaManual}
        footer={
          <React.Fragment>
            <Button label="Fechar" severity="secondary" outlined onClick={fecharDialogoBaixaManual} />
            <Button style={{backgroundColor: '#183462' }} label="Confirmar" onClick={confirmarBaixaManual} />
          </React.Fragment>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="valorPago" className="font-bold block mb-2">{t('valorPagamento')}</label>
            <InputNumber
              id="valorPago"
              value={valorPago}
              onValueChange={(e) => setValorPago(e.value ?? null)}
              mode="currency"
              currency="BRL"
              locale="pt-BR"
              min={0}
            />
          </div>
          <div className="field">
            <label htmlFor="dataPagamento" className="font-bold block mb-2">{t('dataPagamento')}</label>
            <Calendar
              id="dataPagamento"
              value={dataPagamento}
              onChange={(e) => setDataPagamento((e.value as Date) ?? null)}
              dateFormat="dd/mm/yy"
              showIcon
              locale="pt"
            />
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={descontoVisible}
        header="Realizar Desconto"
        modal
        style={{ width: '420px' }}
        onHide={fecharDialogoDesconto}
        footer={
          <React.Fragment>
            <Button label="Fechar" severity="secondary" outlined onClick={fecharDialogoDesconto} />
            <Button style={{backgroundColor: '#183462' }} label="Confirmar" onClick={confirmarDesconto} />
          </React.Fragment>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="valorDesconto" className="font-bold block mb-2">Valor do Desconto</label>
            <InputNumber
              id="valorDesconto"
              value={valorDesconto}
              onValueChange={(e) => setValorDesconto(e.value ?? null)}
              mode="currency"
              currency="BRL"
              locale="pt-BR"
              min={0}
            />
          </div>
          <div className="field">
            <label htmlFor="descricaoDesconto" className="font-bold block mb-2">Descrição</label>
            <InputTextarea
              id="descricaoDesconto"
              value={descricaoDesconto}
              onChange={(e) => setDescricaoDesconto(e.target.value)}
              rows={3}
              autoResize
            />
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={faturaManualVisible}
        header="Nova Fatura Manual"
        modal
        style={{ width: '600px' }}
        onHide={fecharFaturaManual}
        footer={
          <React.Fragment>
            <Button label="Fechar" severity="secondary" outlined onClick={fecharFaturaManual} />
            <Button style={{ backgroundColor: '#183462' }} label="Confirmar" onClick={confirmarFaturaManual} />
          </React.Fragment>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="clienteFaturaManual" className="font-bold block mb-2">{t('cliente')}</label>
            <Dropdown
              id="clienteFaturaManual"
              value={clienteFaturaManual}
              onChange={(e) => setClienteFaturaManual(e.value)}
              options={clients}
              optionLabel="name"
              placeholder="Selecione Cliente"
              filter
            />
          </div>
          <div className="field">
            <label htmlFor="faturamentoFaturaManual" className="font-bold block mb-2">{t('faturamento')}</label>
            <Dropdown
              id="faturamentoFaturaManual"
              value={faturamentoFaturaManual}
              onChange={(e) => setFaturamentoFaturaManual(e.value)}
              options={faturamentos}
              optionLabel="name"
              placeholder="Selecione Faturamento"
              filter
            />
          </div>
          <div className="field">
            <label className="font-bold block mb-2">Tipo</label>
            <Dropdown value={faturaManualTipo} onChange={(e) => setFaturaManualTipo(e.value)} options={tiposFaturaManual} optionLabel="label" optionValue="value" placeholder="Selecione o tipo" />
          </div>
          <div className="field">
            <label className="font-bold block mb-2">Data de Vencimento (opcional)</label>
            <Calendar value={faturaManualVencimento} onChange={(e) => setFaturaManualVencimento((e.value as Date) ?? null)} dateFormat="dd/mm/yy" showIcon locale="pt" />
          </div>
          <div className="field">
            <label className="font-bold block mb-2">Itens</label>
            {faturaManualItens.map((item: any, index: number) => (
              <div key={index} className="flex gap-2 mb-2 align-items-center">
                <InputText placeholder="Descrição" value={item.descricao} onChange={(e) => atualizarItemManual(index, 'descricao', e.target.value)} style={{ flex: 2 }} />
                <InputNumber placeholder="Qtd" value={item.quantidade} onValueChange={(e) => atualizarItemManual(index, 'quantidade', e.value ?? 1)} min={1} style={{ flex: 1 }} />
                <InputNumber placeholder="Valor Unit." value={item.valorUnitario} onValueChange={(e) => atualizarItemManual(index, 'valorUnitario', e.value ?? null)} mode="currency" currency="BRL" locale="pt-BR" style={{ flex: 2 }} />
                {faturaManualItens.length > 1 && (
                  <Button icon="pi pi-trash" severity="danger" text onClick={() => removerItemManual(index)} />
                )}
              </div>
            ))}
            <Button icon="pi pi-plus" label="Adicionar Item" text style={{ color: '#183462' }} onClick={adicionarItemManual} />
          </div>
        </div>
      </Dialog>
    </Container>
  )
}
